import { defineStore } from "pinia";

import { getCompanyId } from "@/utils/userUtils";

import counterpartiesApi from "@/services/api/counterpartiesApi";

export const useCounterpartyStore = defineStore("counterparty", {
  state: () => ({
    counterparties: [],

    companyId: getCompanyId(),

    searchQuery: "",

    pagination: {
      page: 1,
      pages: 1,
      series: [],
      next: null,
      prev: null,
      count: 0,
      limit: 40,
    },

    dataIsLoading: false,
  }),

  actions: {
    async fetchCounterparties(params = {}) {
      this.searchQuery = params.search || "";
      return await this.getCounterpartiesRequest(1);
    },

    async loadMoreCounterparties() {
      if (this.dataIsLoading || !this.pagination.next) {
        return;
      }

      const nextPage = this.pagination.page + 1;
      return await this.getCounterpartiesRequest(nextPage);
    },

    async getCounterpartiesRequest(page) {
      const pageNumber = parseInt(page) || 1;

      try {
        this.dataIsLoading = true;

        const params = {
          page: pageNumber,
          "q[enabled]": "true",
        };

        if (this.searchQuery) {
          params["q[search]"] = this.searchQuery;
        }

        const response = await counterpartiesApi.index(
          this.companyId,
          params
        );

        if (pageNumber === 1) {
          this.counterparties = response.data.result;
        } else {
          this.counterparties = [
            ...this.counterparties,
            ...response.data.result,
          ];
        }

        const meta = response.data.pagination_meta;
        this.pagination = {
          page: meta.page,
          pages: meta.pages,
          series: meta.series,
          next: meta.next,
          prev: meta.prev,
          count: meta.count,
          limit: meta.limit,
        };
      } catch (error) {
        console.error("Ошибка при загрузке контрагентов:", error);
      } finally {
        this.dataIsLoading = false;
      }
    },

    async ensureCounterparty(id) {
      if (!id) return;
      const exists = this.counterparties.find(
        (c) => String(c.id) === String(id)
      );
      if (exists) return;

      try {
        const response = await counterpartiesApi.show(
          this.companyId,
          id
        );
        const counterparty = response.data.result;
        this.counterparties = [...this.counterparties, counterparty];
      } catch (error) {
        console.error(`Ошибка загрузки контрагента #${id}:`, error);
      }
    },

    replaceCounterparty(counterparty) {
      if (!counterparty?.id) return;

      const index = this.counterparties.findIndex(
        (item) => String(item.id) === String(counterparty.id)
      );

      if (index === -1) {
        this.counterparties = [counterparty, ...this.counterparties];
        return;
      }

      this.counterparties.splice(index, 1, counterparty);
    },

    clearCounterparties() {
      this.counterparties = [];
      this.searchQuery = "";
      this.pagination = {
        page: 1,
        pages: 1,
        series: [],
        next: null,
        prev: null,
        count: 0,
        limit: 40,
      };
    },
  },
});
